import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Layout from '@/components/layouts/Layout';
import { ContentProvider } from '@/hooks/useCms';

/**
 * HOC for protected routes that gets the MSAL authentication status
 * and redirects to the login page if user is not authenticated.
 */
function ProtectedRoutes() {
  const { instance, inProgress } = useMsal();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect().catch((error) => {
        console.error('Login redirect failed:', error);
      });
    }
  }, [isAuthenticated, instance, location.pathname, inProgress]);

  if (inProgress !== InteractionStatus.None || !isAuthenticated) {
    return null;
  }

  return (
    <ContentProvider>
      <Layout>
        <Outlet />
      </Layout>
    </ContentProvider>
  );
}

export default ProtectedRoutes;
